import React, { useEffect, useState } from "react";

import { GoKebabHorizontal } from "react-icons/go";
import InfiniteScroll from "react-infinite-scroll-component";

import { deleteChat } from "../../api/chatApi";

import SpinnerIcon from "../../assets/icons/SpinnerIcon";
import AlertOverlay from "../AlertOverlay";
import PopUp from "../PopUp";
import SidebarChatEditLabel from "../SidebarChatEditLabel";
import { useNavigate, useParams } from "react-router-dom";

const Chats = ({
  setNewChat,
  chatList,
  activeChat,
  setActiveChat,
  getAllChats,
  chatLoading,
  setChatLoading,
  chatListTotalCount,
  chatListLimit,
  sidebarSkipRef,
  page,
  setPage,
  isFetchingResponse,
  infiniteScrollHeight,
  stopFetchingResponse,
  setIsStopResponseAlertOverlayOpen,
  isStopResponseAlertOverlayOpen,
}) => {
  const [isEditLabel, setIsEditLabel] = useState(false);
  const [isAlertOverlayOpen, setIsAlertOverlayOpen] = useState(false);
  const [isAlertOverlayDeleteLoading, setIsAlertOverlayDeleteLoading] =
    useState(false);
  const [chatId, setChatId] = useState("");
  const [brandId, setBrandId] = useState("");
  const { chatId: paramsChatId } = useParams();
  const navigate = useNavigate();

  const selectChatHandler = (chatId, brandId) => {
    if (isFetchingResponse) {
      setIsStopResponseAlertOverlayOpen(true);
      return;
    }

    setActiveChat(chatId);
    setNewChat(false);
    setIsEditLabel(false);
    localStorage.setItem("activeBrand", brandId);
    navigate(`/chat/${chatId}`);
  };

  useEffect(() => {
    // getAllChats({ skip: chatListLimit * page });
    getAllChats({ skip: sidebarSkipRef.current, isReset: false });
  }, [page]);

  const onDeleteClick = async () => {
    setChatLoading(true);
    setIsAlertOverlayDeleteLoading(true);
    await deleteChat(activeChat);

    sidebarSkipRef.current = 0;
    setPage(0);
    await getAllChats({});
    setIsAlertOverlayOpen(false);
    setIsAlertOverlayDeleteLoading(false);
    if (chatList.length > 0) {
      setActiveChat(chatList[0]._id);
    } else {
      setActiveChat("");
    }
    setNewChat(true);
  };

  const onEditLabelClick = ({ event }) => {
    event.stopPropagation();
    setIsEditLabel(true);
    setPage(0);
    sidebarSkipRef.current = 0;
  };

  const chatAction = [
    {
      title: "Edit",
      onClick: ({ event }) => {
        onEditLabelClick({ event });
      },
      className: "",
    },
    {
      title: "Delete",
      onClick: () => setIsAlertOverlayOpen(true),
      className: "text-red-500",
    },
  ];

  return (
    <div>
      <div className="flex flex-col bg-zinc-950 text-white">
        <div>
          <InfiniteScroll
            className={`flex flex-col gap-2 pt-2 items-center opacity-90 text-slate-100 relative`}
            dataLength={chatList.length}
            next={() => {
              sidebarSkipRef.current = chatListLimit * (page + 1);
              setPage(page + 1);
            }}
            hasMore={chatListTotalCount > chatList.length}
            height={infiniteScrollHeight - 100}
            loader={
              <div className="p-5">
                <SpinnerIcon className="w-3.5 h-3.5 animate-spin" />
              </div>
            }
          >
            {chatLoading ? (
              <div className="h-[600px] flex justify-center items-center">
                <SpinnerIcon className="w-4 h-4 animate-spin" />
              </div>
            ) : (
              chatList?.map((chat) => {
                const chatCreatedDate = new Date(chat.created_at);
                return (
                  <div
                    title={`${chat.label}, ${chatCreatedDate.toLocaleString()}`}
                    key={chat._id}
                    onClick={() => {
                      setBrandId(chat.client_dataset_id);
                      setChatId(chat._id);
                      selectChatHandler(chat._id, chat.client_dataset_id);
                    }}
                    className={`group/item relative flex rounded-lg p-2 w-[95%] text-sm cursor-pointer ${
                      chat._id === activeChat || chat._id === paramsChatId
                        ? isEditLabel
                          ? "bg-zinc-800 "
                          : " bg-zinc-900 "
                        : "hover:bg-zinc-800 opacity-80"
                    } `}
                  >
                    <div
                      className={`absolute right-2 top-0 bg-gradient-to-l group-hover/item:invisible from-zinc-950 h-full w-12 ${
                        chat._id === activeChat || chat._id === paramsChatId
                          ? "invisible"
                          : ""
                      }`}
                    ></div>
                    {isEditLabel &&
                    (chat._id === activeChat || chat._id === paramsChatId) ? (
                      <SidebarChatEditLabel
                        getAllChats={getAllChats}
                        activeChat={activeChat}
                        chatLabel={chat.label}
                        setIsEditLabel={setIsEditLabel}
                      />
                    ) : (
                      <div className="flex w-full text-xs">
                        <div className="w-full whitespace-nowrap overflow-hidden cursor-pointer self-center text-zinc-100">
                          {chat.label}
                        </div>

                        {(chat._id === activeChat ||
                          chat._id === paramsChatId) && (
                          <div
                            style={{
                              visibility:
                                chat._id === activeChat ? "visible" : "",
                            }}
                            className={`group/edit relative flex justify-end p-0 cursor-pointer invisible group-hover/item:visible`}
                          >
                            <div
                              className={`absolute right-4 top-0 bg-gradient-to-l group-hover/edit:visible from-zinc-900 h-full w-12`}
                            ></div>

                            <PopUp
                              options={chatAction}
                              menuItemsClassName="w-32"
                            >
                              <GoKebabHorizontal
                                size={16}
                                className="items-end rotate-90 "
                              />
                            </PopUp>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </InfiniteScroll>
        </div>
      </div>

      <AlertOverlay
        description={`Do you want to stop response for '${
          chatList.find((chat) => chat._id === activeChat)?.label
        }'`}
        title="Stop Response?"
        primaryActionTitle="Cancel"
        secondaryActionTitle="Stop"
        isOpen={isStopResponseAlertOverlayOpen}
        onClick={async () => {
          setIsStopResponseAlertOverlayOpen(false);
          await stopFetchingResponse();
          setActiveChat(chatId);
          setNewChat(false);
          setIsEditLabel(false);
          localStorage.setItem("activeBrand", brandId);
          navigate(`/chat/${chatId}`);
        }}
        setIsOpen={setIsStopResponseAlertOverlayOpen}
      />

      <AlertOverlay
        description="Are you sure you want to delete this chat?"
        title="Delete Chat"
        primaryActionTitle="Cancel"
        secondaryActionTitle="Delete"
        isOpen={isAlertOverlayOpen}
        onClick={onDeleteClick}
        setIsOpen={setIsAlertOverlayOpen}
        loading={isAlertOverlayDeleteLoading}
      />
    </div>
  );
};

export default Chats;
